(function () {
  const ACCOUNT_SUB_MENU_ID = "mob-db-nav2-menu-sub-nav-item";
  const ACCOUNT_ARROW_ICON_ID = "mob-db-nav2-menu-setting-icon";
  const ACCOUNT_BUTTON_ID = "mob-db-nav2-menu-nav-setting-btn";
  const MENU_DRAWER_CLASS = "custom-db-mobile-menu-drawer-container";

  const accountButton = document.getElementById(ACCOUNT_BUTTON_ID);
  const accountArrowIcon = document.getElementById(ACCOUNT_ARROW_ICON_ID);
  const accountSubMenu = document.getElementById(ACCOUNT_SUB_MENU_ID);

  if (accountButton && accountArrowIcon && accountSubMenu) {
    accountButton.addEventListener("click", (event) => {
      event.stopPropagation();
      const open = accountSubMenu.classList.contains("hidden");
      accountSubMenu.classList.toggle("hidden", !open);
      accountArrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-down", !open);
      accountArrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-up", open);
    });
  }

  if (window.innerWidth > 768) return;

  const menuDrawer = document.querySelector("." + MENU_DRAWER_CLASS);
  if (menuDrawer) {
    menuDrawer.addEventListener("toggle", () => {
      document.body.style.overflow = menuDrawer.open ? "hidden" : "auto";
    });
  }
})();

(function () {
  const ROUTINE_PATH = "/pages/routine";
  const ROUTINE_BUTTON_ID = "mob-rl-nav-menu-btn";
  const ROUTINE_ARROW_ICON_ID = "mob-rl-nav-menu-icon";
  const ROUTINE_SUB_MENU_ID = "mob-rl-nav-menu-sub-nav-item";
  const MENU_DRAWER_CLASS = "custom-db-mobile-menu-drawer-container";

  const routineButton = document.getElementById(ROUTINE_BUTTON_ID);
  const routineArrowIcon = document.getElementById(ROUTINE_ARROW_ICON_ID);
  const routineSubMenu = document.getElementById(ROUTINE_SUB_MENU_ID);
  if (!routineButton || !routineArrowIcon || !routineSubMenu) return;

  function setRoutineMenuOpen(open) {
    routineSubMenu.classList.toggle("hidden", !open);
    routineArrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-down", !open);
    routineArrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-up", open);
  }

  function restoreRoutineTab() {
    const onRoutinePage = window.location.pathname === ROUTINE_PATH;
    const activeTab = new URLSearchParams(window.location.search).get("tab") || "guide";

    routineSubMenu.querySelectorAll("[data-rl-mob-tab]").forEach((item) => {
      item.classList.toggle("active", onRoutinePage && item.dataset.rlMobTab === activeTab);
    });
    if (onRoutinePage) setRoutineMenuOpen(true);
  }

  routineButton.addEventListener("click", (event) => {
    event.stopPropagation();
    setRoutineMenuOpen(routineSubMenu.classList.contains("hidden"));
  });

  const menuDrawer = document.querySelector("." + MENU_DRAWER_CLASS);
  if (menuDrawer) {
    menuDrawer.addEventListener("toggle", () => {
      if (menuDrawer.open) restoreRoutineTab();
    });
  }

  restoreRoutineTab();
})();
